export function cycleState<T>(possibilities: T[], currentState: T) {
  const { length } = possibilities;
  const index = possibilities.findIndex(
    (current: T) => current === currentState
  );
  //Trick for cycling - nice and clean: The first item will be taken from the beginning of the array after the last item
  return possibilities[(index + 1) % length];
}

export function reorder<T>(list: T[], startIndex: number, endIndex: number) {
  const result = [...list];
  const [removed] = result.splice(startIndex, 1);
  if (removed) result.splice(endIndex, 0, removed);
  return result.map((selection, i) => ({ ...selection, order: i }));
}
